<template>
  <select
    class="ha-builder-control"
    :value="modelValue"
    @change="$emit('update:modelValue', $event.target.value)">
    <slot />
  </select>
</template>

<script setup>
/**
 * BuilderSelect.vue
 *
 * The dense, dark-panel <select> used throughout the Home Assistant
 * builder dialogs (State Bindings, Trigger Rules, …) — matches the
 * bg-slate-700/text-white/border-slate-500 pattern already established
 * by ChartSeriesTable.vue.
 * Deliberately separate from the global form-select component: that one
 * is styled for the light property-panel forms and can't be restyled
 * from a usage site (its class lands on a wrapper div, not the actual
 * <select> — see its own template). This component's root IS the
 * <select>, so size/spacing classes passed at the call site (`w-20`,
 * `text-sm`, …) land directly on it via normal Vue attribute inheritance.
 *
 * Sizing/padding/font-size are intentionally not hardcoded here — callers
 * set them (e.g. `class="text-xs px-1 py-0.5"` for a compact inline row,
 * `class="w-full text-sm px-1 py-1"` for a full-width field), the same
 * way the raw <select> elements this replaces did.
 */
defineProps({
  modelValue: { type: [String, Number], default: '' },
});
defineEmits(['update:modelValue']);
</script>
